const UPDATE_RESOURCESSUBTYPE = 'resourcesSubTypes/UPDATE_RESOURCESSUBTYPE';
const SET_SELECTED_RESOURCESSUBTYPE = 'resourcesSubTypes/SET_SELECTED_RESOURCESSUBTYPE';
const UPDATE_LOADED = 'resourcesSubTypes/UPDATE_LOADED';

export default {
  UPDATE_RESOURCESSUBTYPE,
  SET_SELECTED_RESOURCESSUBTYPE,
  UPDATE_LOADED
};
